import { render, staticRenderFns } from "./IssueTypeDetails.vue?vue&type=template&id=51c286a4&scoped=true&"
import script from "./IssueTypeDetails.vue?vue&type=script&lang=js&"
export * from "./IssueTypeDetails.vue?vue&type=script&lang=js&"
import style0 from "./IssueTypeDetails.vue?vue&type=style&index=0&id=51c286a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c286a4",
  null
  
)

export default component.exports